import React, { useEffect, useRef, useState } from 'react'
import './Page-css/Client_RegisterUser.css'
import ClientNavbar from './ClientNavbar'
import ClientNavbar2 from './ClientNavbar2'
import { toast } from 'react-toastify'
import { Icon } from '@iconify/react'
import { useAuth } from '../../Context/UserContext'
import { url } from '../../constants/url'
import ClientNavbar1 from './ClientNavbar1';
import AddUserModal from '../Modal/AddUserModal'
import { Delete } from '../Modal/Delete'

const Client_RegisterUser = () => {
  const [openAddUserModal, setOpenAddUserModal] = useState(false);
  const [deleteModalOpen, setDeleteModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState("all");
  const [isMobile, setIsMobile] = useState(window.innerWidth < 620);
  const [developerName, setDeveloperName] = useState("");
  const [developerEmail, setDeveloperEmail] = useState("");
  const [developerRole, setDeveloperRole] = useState("");
  const [developerPermission, setDeveloperPermission] = useState("");
  // const [developerPassword, setDeveloperPassword] = useState("");

  const [developerNameError, setDeveloperNameError] = useState("");
  const [developerEmailError, setDeveloperEmailError] = useState("");
  const [developerRoleError, setDeveloperRoleError] = useState("");
  const [developerPermissionError, setDeveloperPermissionError] = useState("");
  // const [developerPasswordError, setDeveloperPasswordError] = useState("");

  const [openClientDropdown, setOpenClientDropdown] = useState(false);
  const [inputFocused, setInputFocused] = useState(false);
  const [userTypeFilter, setUserTypeFilter] = useState("All");
  const [clientQuery, setClientQuery] = useState("");
  const [openRegClient, setOpenRegClient] = useState(false);
  const [userQuery, setUserQuery] = useState("");
  const [clientRegisteredData, setClientRegisteredData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const { userRole, isSidebarCollapsed, logout, userPermission } = useAuth();
  const [editModalOpen, setEditModalOpen] = useState(false)

  const [deleteClient, setDeleteClient] = useState(false);
  const [selectedClientId, setSelectedClientId] = useState(null);

  const filterUserRef = useRef(null);

  const userPerPage = 15;
  const startIndex = (currentPage - 1) * userPerPage + 1;
  const endIndex = startIndex + userPerPage;

  const validateEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const specialChars = /[!@#$%^&*(),.?":{}|<>]/;

  const handleRegisterUser = () => {
    setOpenRegClient(false);
    setDeveloperName("");
    setDeveloperEmail("");
    setDeveloperRole("");
    setDeveloperPermission("")
    // setDeveloperPassword("");
    setDeveloperNameError("");
    setDeveloperEmailError("");
    setDeveloperRoleError("");
    setDeveloperPermissionError("")
    // setDeveloperPasswordError("");
  };

  const handleClientSearchInput = (event) => {
    setClientQuery(event.target.value);
  };


  const getTotalPages = () => {
    return Math.ceil((filteredUsers ?? []).length / userPerPage);
  };

  const handlePreviousPage = () => {
    setCurrentPage((prevPage) => (prevPage > 1 ? prevPage - 1 : prevPage));
  };

  const handleNextPage = () => {
    setCurrentPage((prevPage) =>
      prevPage < getTotalPages() ? prevPage + 1 : prevPage
    );
  };

  // Refer users.js for backend code
  const handleDeveloperRegister = async () => {
    if (developerName === "") {
      setDeveloperNameError("This field is required");
      return;
    }
    if (specialChars.test(developerName)) {
      setDeveloperNameError("Invalid input");
      return;
    }

    if (developerEmail === "") {
      setDeveloperEmailError("This field is required");
      return;
    }
    if (!validateEmail(developerEmail)) {
      setDeveloperEmailError("Invalid email");
      return;
    }
    if (developerPermission === "") {
      setDeveloperPermissionError("This field is required");
      return;
    }
    if (developerRole === "") {
      setDeveloperRoleError("This field is required");
      return;
    }


    try {
      const response = await fetch(`${url}/registerdeveloper`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          developerName,
          developerEmail,
          developerPermission,
          developerRole,
        }),
      });

      if (response.ok) {
        toast.success("User registered successfully...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        setDeveloperEmail("");
        setDeveloperName("");
        setDeveloperRole("");
        setDeveloperPermission("")
        fetchRegisteredClientUser();
        setOpenRegClient(false);
        return;
      }
      if (response.status === 302) {
        toast.error("User already exist...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      if (response.status === 400) {
        toast.error("Bad Request", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      if (response.status === 403) {
        toast.error("Invalid Email", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      return response;
    } catch (error) {
      console.log(error);
      toast.error(error.response.data.message, {
        position: "top-center",
        autoClose: 5000,
        pauseOnHover: false,
      });
    }
  };

  //  Refer users.js for backend code
  const fetchRegisteredClientUser = async () => {
    try {
      const response = await fetch(
        `${url}/fetchregisteredclientuser`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        }
      );
      const data = await response.json();
      setClientRegisteredData(data);

      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  //  Refer users.js for backend code
  const handleDeleteClient = async () => {
    try {
      const response = await fetch(`${url}/deleteregisteredclient`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify({
          userId: selectedClientId,
        }),
      }
      );
      if (response.ok) {
        toast.success("User deleted successfully...", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
        fetchRegisteredClientUser();
        setDeleteModalOpen(false)
        setDeleteClient(false);
      }
      if (response.status === 404) {
        toast.error("User not found", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      if (response.status === 440) {
        logout();
        toast.error("User logout due to inactivity", {
          position: "top-right",
          autoClose: 2500,
          pauseOnHover: false,
        });
      }
      return response;
    } catch (error) {
      console.log(error);
    }
  };



  useEffect(() => {
    fetchRegisteredClientUser();
    if (userPermission !== "level 1" && userPermission !== "level 2") {
      logout();
    }
    return;
  }, []);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 620);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const permissionFrontendMap = {
    "executive policy": "level 1",
    "manager policy": "level 2",
    "lead policy": "level 3",
    "engineer policy": "level 4"
  };


  const filteredUsers = Array.isArray(clientRegisteredData)
    ? clientRegisteredData.filter((user) => {
      const matchesSearch =
        user.name.toLowerCase().includes(clientQuery.toLowerCase()) ||
        user.email.toLowerCase().includes(clientQuery.toLowerCase());

      const matchesRole =
        userTypeFilter === "All" ||
        user.permission === permissionFrontendMap[userTypeFilter.toLowerCase()];

      return matchesSearch && matchesRole;
    })
    : [];

  const formatDate = (dateString) => {
    const options = { day: "2-digit", month: "2-digit", year: "numeric" };
    const date = new Date(dateString);
    return date.toLocaleDateString("en-GB", options);
  };

  const sortedUsers = [...filteredUsers].sort(
    (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
  );

  const handleClickUserOut = (event) => {
    if (
      filterUserRef.current &&
      !filterUserRef.current.contains(event.target)
    ) {
      setOpenClientDropdown(false);
    }
  };

  useEffect(() => {
    if (openClientDropdown) {
      document.addEventListener("mousedown", handleClickUserOut);
    } else {
      document.removeEventListener("mousedown", handleClickUserOut);
    }
    return () => {
      document.removeEventListener("mousedown", handleClickUserOut);
    };
  }, [openClientDropdown]);

  const capitalizeFirstLetter = (string) =>
    string.charAt(0).toUpperCase() + string.slice(1);

  const permissionMap = {
    "level 1": "Executive Policy",
    "level 2": "Manager Policy",
    "level 3": "Lead Policy",
    "level 4": "Engineer Policy",
  };

  function getPermissionLabel(perm) {
    if (!perm) return "";

    const match = String(perm).toLowerCase().match(/level\s*([1-4])/i);
    if (match) {
      const key = `level ${match[1]}`;
      return permissionMap[key] || "";
    }
    return String(perm).charAt(0).toUpperCase() + String(perm).slice(1);
  }

  return (
    <div className="client-table-list-dash">
      <div>
        <div className='client_navabr1'>
          <ClientNavbar1 />
        </div>
        <div className='navbar_second'><ClientNavbar2 /></div>
      </div>
      <div className="wrap_navbar_dashboard">
        <div className={isSidebarCollapsed ? 'clientdash-navbar' : 'clientdash_close_navbar'}>
          <ClientNavbar />
        </div>

        <div className='manage_user_container'>
          <div className='manage_user_main_content'>

            <div className='manage_user_header_and_filter'>
              <h2>View and add users</h2>
            </div>

            {/* search and add user section */}
            <div className='manage_user_search_and_button'>
              {!isMobile && (
                <div className='manage_user_filter'>
                  <label>Group by</label>
                  <div className='manage_user_filter_select' style={{ position: 'relative' }}>
                    <div
                      className="custom-select-client"
                      onClick={() => setOpenClientDropdown((prev) => !prev)}
                    >
                      <span style={{ marginRight: 8, color: '#202123CC' }}>{userTypeFilter}</span>
                      <Icon
                        icon={openClientDropdown ? "ic:round-arrow-drop-up" : "ic:round-arrow-drop-down"}
                        width="24"
                        height="24"
                        style={{ color: "#E76A34" }}
                      />
                    </div>
                    {openClientDropdown && (
                      <ul
                        className="custom-dropdown"
                        ref={filterUserRef}

                      >
                        {["All", "Executive Policy", "Manager Policy", "Lead Policy", "Engineer Policy"].map(option => (
                          <li
                            key={option}
                            className={userTypeFilter === option ? "selected" : ""}
                            onClick={() => {
                              setUserTypeFilter(option);
                              setOpenClientDropdown(false);
                            }}
                          >
                            {option}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </div>

              )}
              <div className='manage_user_search'>
                <Icon icon="ic:round-search" width="20" height="20" style={{ color: "#E76A34", marginRight: "8px" }} />
                <input
                  type="text"
                  style={{
                    padding: '5px'
                  }}
                  placeholder="Search by name, email....."
                  onChange={handleClientSearchInput}
                  value={clientQuery}
                  data-testid="search-input"
                  onFocus={() => setInputFocused(true)}
                  onBlur={() => setInputFocused(false)}
                />
              </div>
              <div className='user_add_btn'>
                <button className='create_button' onClick={() => setOpenAddUserModal(true)}>
                  +  Add User
                </button>
                {isMobile && (
                  <div className='manage_user_filter'>
                    <label>Group by</label>
                    <div className='manage_user_filter_select' style={{ position: 'relative' }}>
                      <div
                        className="custom-select-client"
                        onClick={() => setOpenClientDropdown((prev) => !prev)}
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'space-between',
                          cursor: 'pointer',
                          minWidth: 120,
                          border: '1.5px solid #2E89E4',
                          borderRadius: 8,
                          padding: '4px 12px',
                          fontSize: '14px',
                          background: '#fff',
                          boxShadow: openClientDropdown ? '0 2px 8px rgba(46, 137, 228, 0.08)' : 'none',
                        }}
                      >
                        <span style={{ marginRight: 8 }}>{userTypeFilter}</span>
                        <Icon
                          icon={openClientDropdown ? "ic:round-arrow-drop-up" : "ic:round-arrow-drop-down"}
                          width="24"
                          height="24"
                          style={{ color: "#2E89E4" }}
                        />
                      </div>
                      {openClientDropdown && (
                        <ul
                          className="custom-dropdown"
                          ref={filterUserRef}
                          style={{
                            position: 'absolute',
                            top: '110%',
                            left: 0,
                            width: '100%',
                            fontSize: '12px',
                            background: '#fff',
                            border: '1.5px solid #2E89E4',
                            borderRadius: 5,
                            boxShadow: '0 2px 8px rgba(46, 137, 228, 0.12)',
                            zIndex: 10,
                            margin: 0,
                            padding: 0,
                            listStyle: 'none'
                          }}
                        >
                          {["All", "Executive Policy", "Manager Policy", "Lead Policy", "Engineer Policy"].map(option => (
                            <li
                              key={option}
                              onClick={() => {
                                setUserTypeFilter(option);
                                setOpenClientDropdown(false);
                              }}
                              style={{
                                padding: '8px 16px',
                                cursor: 'pointer',
                                background: userTypeFilter === option ? '#eaf4fd' : '#fff',
                                color: userTypeFilter === option ? '#2E89E4' : '#202123CC'
                              }}
                              onMouseEnter={e => e.target.style.background = '#eaf4fd'}
                              onMouseLeave={e => e.target.style.background = userTypeFilter === option ? '#eaf4fd' : '#fff'}
                            >
                              {option}
                            </li>
                          ))}
                        </ul>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>

            {/* registered user table */}
            <div className='manage_user_table'>
              <table>
                <thead className='manage_user_table_header'>
                  <tr>
                    <th>SI No</th>
                    <th>Name</th>
                    <th><Icon icon="circum:mail" width="18" height="18" />Email</th>
                    <th>Permission</th>
                    <th><Icon icon="proicons:person" width="16" height="16" />Role</th>
                    <th><Icon icon="formkit:date" width="16" height="16" />Created Date</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody className='manage-user-table-main-container-body'>
                  {filteredUsers.length === 0 ? (
                    <tr className='collapsetable' >
                      <td colSpan='8'>User Not Found....</td>
                    </tr>
                  ) : (
                    sortedUsers.map((user, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{user.name}</td>
                        <td>{user.email}</td>
                        <td>{getPermissionLabel(user.permission)}</td>
                        <td>{user.role ? user.role.charAt(0).toUpperCase() + user.role.slice(1) : ''}</td>
                        <td>{formatDate(user.createdAt)}</td>
                        <td>
                          <Icon
                            icon="ri:edit-2-line"
                            width="24"
                            height="24"
                            style={{ color: "#1E90FF", cursor: "pointer", marginRight: "10px" }}
                            onClick={() => {
                              setEditModalOpen(true);
                              setSelectedClientId(user._id);
                            }}
                          />

                          <Icon
                            icon="material-symbols-light:delete-outline-rounded"
                            width="24"
                            height="24"
                            style={{ color: "#E76A34", cursor: "pointer" }}
                            onClick={() => {
                              setDeleteModalOpen(true);
                              setDeleteClient(true);
                              setSelectedClientId(user._id);
                            }}
                          />
                        </td>


                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <AddUserModal
        selectedUser={selectedClientId}
        setSelectedUser={setSelectedClientId}
        editModalOpen={editModalOpen}
        setEditModalOpen={setEditModalOpen}
        open={openAddUserModal}
        setOpenAddUserModal={setOpenAddUserModal}
        handleRegisterUser={handleRegisterUser}
        developerName={developerName}
        setDeveloperName={setDeveloperName}
        capitalizeFirstLetter={capitalizeFirstLetter}
        setDeveloperNameError={setDeveloperNameError}
        developerNameError={developerNameError}
        developerEmail={developerEmail}
        setDeveloperEmail={setDeveloperEmail}
        setDeveloperEmailError={setDeveloperEmailError}
        developerEmailError={developerEmailError}
        developerRole={developerRole}
        setDeveloperRole={setDeveloperRole}
        developerPermission={developerPermission}
        setDeveloperPermission={setDeveloperPermission}
        developerPermissionError={developerPermissionError}
        setDeveloperPermissionError={setDeveloperPermissionError}
        setDeveloperRoleError={setDeveloperRoleError}
        developerRoleError={developerRoleError}
        handleDeveloperRegister={handleDeveloperRegister}
        fetchRegisteredClientUser={fetchRegisteredClientUser}
      />

      <Delete deleteModalOpen={deleteModalOpen} setDeleteModalOpen={setDeleteModalOpen} handleDeleteClient={handleDeleteClient} />
    </div >
  );
};

export default Client_RegisterUser;
